<template>
    <div>
        <v-card v-if="predeterminado" class="mb-4 director" :key="predeterminado.video_id">
            <div class="director__cabecera">
                <v-icon color="secondary" class="mr-2">smart_display</v-icon>
                <div class="director__textos">
                    <div class="director__titulo">{{ predeterminado.titulo }}</div>
                    <div class="director__subtitulo">Un mensaje para los participantes de INFOP</div>
                </div>
                <v-spacer></v-spacer>
                <v-btn small text color="primary" v-if="silenciado" @click="activarSonido">
                    <v-icon small left>volume_up</v-icon> Activar sonido
                </v-btn>
            </div>
            <div class="director__marco">
                <reproductor-video
                    ref="reproductor"
                    :video-url="predeterminado.video_url"
                    :youtube-id="predeterminado.video_youtube_id"
                    autoplay silenciado controles
                    @inicio="registrar('inicio')"
                    @fin="registrar('fin')"
                    @silencio="silenciado = $event"
                    @error="predeterminado = null"
                />
            </div>
        </v-card>

        <video-promocional :video="promocional" @cerrado="promocional = null"/>
    </div>
</template>

<script>
/**
 * Video predeterminado (del director) en el inicio del participante: tarjeta
 * con reproductor que arranca en silencio y en automático si el navegador lo
 * permite. Se pausa mientras suena un video de felicitación (evento global
 * "video-felicitacion") y se reanuda al terminar. También trae del API el
 * promocional que toque hoy y lo delega a VideoPromocional.
 */
import ReproductorVideo from "./ReproductorVideo.vue";
import VideoPromocional from "./VideoPromocional.vue";

const CLAVE_VISITA = "video_promocional_visita";

export default {
    name: "VideoPredeterminado",
    components: {ReproductorVideo, VideoPromocional},
    data() {
        return {
            predeterminado: null,
            promocional: null,
            silenciado: true,
            alFelicitar: null,
        };
    },
    methods: {
        cargar() {
            // No más de un promocional por visita (pestaña del navegador).
            let yaMostrado = false;
            try {
                yaMostrado = !!sessionStorage.getItem(CLAVE_VISITA);
            } catch (e) { /* almacenamiento no disponible */ }

            const params = yaMostrado ? {promocional: 0} : {};
            window.axios.get("/videos/para_mi", {params}).then(response => {
                if (!response.data.success) return;
                this.predeterminado = response.data.data.predeterminado;
                this.promocional = response.data.data.promocional;
            }).catch(() => { /* sin videos: la tarjeta no se muestra */ });
        },
        registrar(evento) {
            if (!this.predeterminado) return;
            window.axios.post("/videos/evento", {video_id: this.predeterminado.video_id, evento}).catch(() => {});
        },
        activarSonido() {
            if (this.$refs.reproductor) this.$refs.reproductor.silenciar(false);
            this.silenciado = false;
        },
        escucharFelicitacion(evento) {
            const reproductor = this.$refs.reproductor;
            if (!reproductor) return;
            if (evento.detail === "inicio") reproductor.pausar();
            if (evento.detail === "fin") reproductor.reanudar();
        },
    },
    created() {
        this.alFelicitar = (evento) => this.escucharFelicitacion(evento);
        window.addEventListener("video-felicitacion", this.alFelicitar);
        this.cargar();
    },
    beforeDestroy() {
        window.removeEventListener("video-felicitacion", this.alFelicitar);
    },
}
</script>

<style lang="scss" scoped>
.director {
    overflow: hidden;
    border-radius: 14px !important;
}

.director__cabecera {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    padding: 12px 16px;
    background: #203d89;
    color: #fff;
}

.director__textos {
    display: flex;
    flex-direction: column;
    line-height: 1.25;
}

.director__titulo {
    font-weight: 700;
    font-size: .98rem;
}

.director__subtitulo {
    font-size: .78rem;
    opacity: .78;
}

.director__cabecera .v-btn {
    background: #fff;
}

.director__marco {
    background: #000;
    max-width: 960px;
    margin: 0 auto;
}
</style>
